import Component from "./Component.js"

export default class Auth extends Component {

  static get contextTypes() {
    return super.contextTypes
  }

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-auth")
    this.state.children = null
    this.player.addEventListener(akamai.amp.AuthEvents.CHOOSE_PROVIDER, this.onchooseprovider.bind(this))
  }

  onchooseprovider(event) {
    // create thumbnail grid
    const response = event.detail
    const idps = response.possible_idps
    const groups = response.grouped_idps
    const logos = response.featured || {}
    const base = logos.base || ""
    const items = []
    let label = "Providers: "
    let featured = ""

    if (groups != null && logos.group != null) {
      const featuredGroup = groups.filter(group => group.name === logos.group)[0]
      if (featuredGroup != null) {
        featuredGroup.members.forEach((member, index) => {
          const idp = idps[member]
          let img = null
          const onclick = this.player.auth.login.bind(this.player.auth, member)
          if (idps[member].logos && idps[member].logos[logos.key]) {
            const idp = idps[member]
            let src = idp.logos[logos.key]
            if (src.indexOf("http") === -1)
              src = base + src
            img = <img className="amp-auth-chooser-grid-cell-img" src={src} alt={idp.display_name}></img>
          }
          items.push(
            <div className="amp-auth-chooser-grid-item" onClick={onclick} key={index}>
              {img}
              <span className="amp-auth-chooser-grid-cell-label">{idp.display_name}</span>
            </div>
          )
        })
      }
    }

    if (items.length > 0) {
      this.classList.add("amp-auth-chooser-featured")
      label = "Other "
    }

    // populate select menu
    const footprints = response.footprints || []
    const options = []

    footprints.forEach((key) => {
      options.push(<option value={key} key={"fp_" + key}>{idps[key].display_name}</option>)
    })

    for (let key in idps) {
      options.push(<option value={key} key={key}>{idps[key].display_name}</option>)
    }

    const onclick = (event) => {
      const select = document.querySelector(".amp-auth-chooser-select")
      const idpId = select.options[select.selectedIndex].value
      this.player.auth.login(idpId)
    }

    this.setState({children: (
      <div className="amp-auth-chooser">
        <div className="amp-auth-chooser-title">Choose your provider</div>
        <div className="amp-auth-chooser-grid">
          {items}
        </div>
        <div className="amp-auth-chooser-menu">
          <div className="amp-auth-chooser-label">{label}</div>
          <select className="amp-auth-chooser-select">
            {options}
          </select>
          <button className="amp-auth-chooser-login" onClick={onclick}>Login</button>
        </div>
      </div>
    )})
  }

  get children() {
    return this.state.children
  }
}
